import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils'

export function integrationLogsLoad(filters) {
  return {
    type: 'INTEGRATION_LOGS_LOAD',
    payload: handleAPI(`/${API_VERSION_ONE}/integration_logs`, filters, 'GET'),
  }
}
